export default function SeeImagen({url}){
    return(
        <img src={url} alt="image" width={'80%'} style={{borderRadius:4}} />
    )

}